export default __webpack_public_path__ + "df2baac3f60d176736faed7517b472f1.woff";